import type { ParseSpec } from "@ext/markdown/core/edit/logic/Prosemirror/from_markdown";
import type PrivateParserContext from "@ext/markdown/core/Parser/ParserContext/PrivateParserContext";
import type { FragmentReference } from "@ext/markdown/elements/fragment/edit/model/types";
import { resolveFragment } from "@ext/markdown/elements/fragment/logic/resolveFragment";

const toMarkupValue = (value: unknown) =>
	typeof value === "number" || typeof value === "boolean" ? `${value}` : value;

const fragmentToken = (context?: PrivateParserContext): ParseSpec => {
	return {
		node: "fragment",
		getAttrs: async (tok) => {
			const reference: FragmentReference = { id: tok.attrs.id, type: tok.attrs.type, branch: tok.attrs.branch };
			// `comment` comes from the enclosing <comment> tag, which the comment formatter writes back itself.
			const { comment: _, ...tagAttrs } = tok.attrs;
			const markupAttrs = Object.fromEntries(
				Object.entries(tagAttrs).map(([name, value]) => [name, toMarkupValue(value)]),
			);
			if (!context) return { ...reference, markupAttrs, content: null, title: null };

			return { ...reference, markupAttrs, ...(await resolveFragment(context, reference)) };
		},
	};
};
export default fragmentToken;
